import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=5b37d111&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=5b37d111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37d111",
  null
  
)

export default component.exports